import * as React from 'react';

import ProjectSubsection from './ProjectSubsection';

export default () => (
  <div className="subsection">
    <div className="title">
      <div className="title-group">
        <h2>Missouri University of Science and Technology</h2>
      </div>
    </div>
    <div className="details">
      Computer Science B.S.
    </div>
  </div>
);
